export default "__VITE_ASSET__7FPE2zuk__"